export default function home_music() {
	
	$('.block-music .music-list').owlCarousel({
    items: 2,
    dotsEach: false,
    loop: true,
    nav: true,
    smartSpeed: 1000,
    mouseDrag: false,
    touchDrag: false,
    margin: 15,
    navText: ['<i class="fas fa-arrow-left"></i>','<i class="fas fa-arrow-right"></i>'],
    responsive: {
      768: {
        items: 4,
        margin: 30
      }
    }
  });
	
}